/* Adikopas — kolekcijų naršyklės mobilus mygtukas rodomas tik ties pačia naršykle */
(function () {
  var CSS = '.adk-nav-toggle-off{opacity:0!important;pointer-events:none!important;transform:translateX(-130%)!important}' +
    '[class*="mobile-toggle-button"]{transition:opacity .18s ease,transform .18s ease}';

  function css() {
    if (document.getElementById('adk-navtoggle-css')) return;
    var s = document.createElement('style');
    s.id = 'adk-navtoggle-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function init() {
    var btn = document.querySelector('[class*="mobile-toggle-button"]');
    var section = document.querySelector('[id*="collection_navigator"]');
    if (!btn || !section) return false;
    if (btn.getAttribute('data-adk-bound')) return true;
    btn.setAttribute('data-adk-bound', '1');
    css();

    function apply(visible) {
      var overlay = document.querySelector('[class*="mobile-overlay"]');
      var open = overlay && getComputedStyle(overlay).visibility !== 'hidden';
      if (visible || open) btn.classList.remove('adk-nav-toggle-off');
      else btn.classList.add('adk-nav-toggle-off');
    }

    apply(false);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { apply(e.isIntersecting); });
      }, { rootMargin: '-60px 0px -20% 0px' }).observe(section);
    } else {
      var check = function () {
        var r = section.getBoundingClientRect();
        apply(r.top < window.innerHeight * 0.8 && r.bottom > 60);
      };
      check();
      window.addEventListener('scroll', check, { passive: true });
    }
    return true;
  }

  if (!init()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (init() || tries > 40) clearInterval(t);
    }, 250);
  }
})();

/* Adikopas — lipni klubo antraštė mobiliajame susitraukia, kai prilimpa prie viršaus */
(function () {
  var CSS = '@media (max-width:749px){' +
    '.adk-clubbar{transition:height .18s ease,padding-block .18s ease}' +
    '.adk-clubbar>h2{transition:font-size .18s ease}' +
    '.adk-clubbar--min{height:auto!important;min-height:0!important;padding-block:10px!important}' +
    '.adk-clubbar--min>p{display:none!important}' +
    '.adk-clubbar--min>h2{font-size:1rem!important;line-height:1.25!important}' +
    '}';

  function css() {
    if (document.getElementById('adk-clubbar-css')) return;
    var s = document.createElement('style');
    s.id = 'adk-clubbar-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function init() {
    var bar = document.querySelector('[class*="collection-header-template--"]');
    if (!bar) return false;
    if (bar.getAttribute('data-adk-bar')) return true;
    bar.setAttribute('data-adk-bar', '1');
    bar.classList.add('adk-clubbar');
    css();

    var stickTop = parseFloat(getComputedStyle(bar).top) || 0;
    var ticking = false;

    function check() {
      ticking = false;
      if (window.innerWidth > 749) {
        bar.classList.remove('adk-clubbar--min');
        return;
      }
      if (bar.getBoundingClientRect().top <= stickTop + 1) {
        bar.classList.add('adk-clubbar--min');
      } else {
        bar.classList.remove('adk-clubbar--min');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }

    check();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return true;
  }

  if (!init()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (init() || tries > 40) clearInterval(t);
    }, 250);
  }
})();
